import React from 'react'

const SVG = ({
  style = {},
  fill = '#5F5F5F',
  width = '100%',
  height = '100%',
  className = '',
  viewBox = '0 0 20 23'
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    xmlns='http://www.w3.org/2000/svg'
    className={`svg-icon ${className || ''}`}
  >
    <g transform='translate(-8.028 -9.652)'>
      <path
        fill={fill}
        d='M27.7,14.3c-0.2-0.1-0.5-0.1-0.7,0l-2.1,1.2c0,0.7-0.1,1.3-0.4,1.9l2.1-1.2v11.9l-4.4,2.6v-9.3
            L21.7,22c-0.3,0.4-0.6,0.9-1,1.4v7.3l-5.3-2.7v-4.6c-0.4-0.5-0.7-1-1-1.4l-0.5-0.7v6.8l-4.4,2.6V18.7l2.1-1.2
            c-0.2-0.5-0.3-1-0.4-1.5l-2.8,1.6C8.2,17.8,8,18.1,8,18.3v13.6c0,0.3,0.1,0.5,0.4,0.6c0.2,0.1,0.5,0.1,0.7,0l5.6-3.2l6.4,3.2
            c0,0,0,0,0,0c0.1,0,0.2,0.1,0.3,0.1h0c0,0,0,0,0.1,0c0.1,0,0.2,0,0.3-0.1c0,0,0,0,0,0l5.9-3.4c0.2-0.1,0.4-0.4,0.4-0.6V14.9
            C28,14.7,27.9,14.4,27.7,14.3z'
      />
      <path
        fill={fill}
        d='M17.5,24c0,0.1,0.1,0.1,0.2,0.2c0.3,0.2,0.7,0.1,0.9-0.1c0,0,0,0,0,0c4-6,4.7-6.7,4.7-8.9
            c0.1-3-2.3-5.4-5.2-5.5c-3,0.1-5.3,2.5-5.2,5.5C12.8,17.4,13.5,18,17.5,24L17.5,24z M15.8,15.2c0.1-1.2,1.1-2.1,2.3-2.1
            c1.2,0.1,2.1,1.1,2.1,2.3c-0.1,1.2-1,2.1-2.2,2.1C16.8,17.4,15.8,16.4,15.8,15.2z'
      />
    </g>
  </svg>
)

export default SVG
